function DevicePage() {
    /**
     *
     */
    DevicePage.prototype.initialize = function (console, device) {
        this.id = "device";
        this.console = console;
        this.device = device;

        return this;
    };

    /**
     *
     */
    DevicePage.prototype.show = function () {
        var deferred = $.Deferred();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    DevicePage.prototype.getResourceUrl = function (device, stateVariable) {
        return ConsoleService.instance().getDeviceStateResourceUrl(device, stateVariable);
    };

    /**
     *
     */
    DevicePage.prototype.leave = function () {
    };
}
